import { useApp } from "@/context/AppContext";
import { PageHeader } from "@/components/PageHeader";
import { StatistiquesCard } from "@/components/dashboard/StatistiquesCard";
import { Etat104Card } from "@/components/dashboard/Etat104Card";
import { G50Card } from "@/components/dashboard/G50Card";

export function ImpotsPage() {
  const { societeId, exercice } = useApp();
  return (
    <div data-testid="impots-page">
      <PageHeader title="Impôts" subtitle="État mensuel G50 : TVA collectée et droit de timbre" />
      <G50Card societeId={societeId} exercice={exercice} />
    </div>
  );
}

export function StatistiquesPage() {
  const { societeId, exercice } = useApp();
  return (
    <div data-testid="statistiques-page">
      <PageHeader title="Statistiques des ventes" subtitle="Synthèse annuelle, CA mensuel, top clients et top produits" />
      <StatistiquesCard societeId={societeId} exercice={exercice} />
    </div>
  );
}

export function Etat104Page() {
  const { societeId, exercice } = useApp();
  return (
    <div data-testid="etat104-page">
      <PageHeader title="État 104" subtitle="État des clients : RC, NIF, N° article, montant HT et TVA" />
      <Etat104Card societeId={societeId} exercice={exercice} />
    </div>
  );
}
